import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClipboardPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "var(--icon-color, currentColor)",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 4,
			x: 8,
			y: 2,
			rx: 1,
			ry: 1
		}),
		/* @__PURE__ */ _jsx("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 14h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 17v-6" })
	]
});
export default SvgClipboardPlus;
